import React from 'react';
import i18n from 'i18next';

import { Typo } from 'uikit/content';

import VideoTopicWidgetItem from './videoTopicWidgetItem';

import styles from '../styles/videoTopicWidget.module.scss';

export default ({
  name,
  topic,
  currentVideoId,
}) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <Typo variant="b02" weight="medium">
        {i18n.t('more-from-name', { name })}
      </Typo>
    </div>
    <ul>
      {topic.data.map(({
        duration, cover_art: coverArt, name, id,
      }) => (
        <VideoTopicWidgetItem
          key={id}
          name={name}
          duration={duration}
          picture={coverArt}
          id={id}
          isActive={id === Number(currentVideoId)}
        />
      ))}
    </ul>
  </div>
);
